const loadCollapsibleListModule = () => ({
    hasRouter: false,
    modules: [],
});
export default loadCollapsibleListModule;
